import {
  countRemittances,
  createRemittance,
  getRemittances,
  updateRemittance,
  deleteAllRemittances
} from '../../../utils'

export { countRemittances, createRemittance, getRemittances, updateRemittance, deleteAllRemittances }

export default {
  countRemittances,
  createRemittance,
  getRemittances,
  updateRemittance,
  deleteAllRemittances
}
